import { Trans } from 'react-i18next'

import styled from 'styled-components'
import quizResultPNG from '~/assets/images/art/quiz-result.png'
import quizResultWEBP from '~/assets/images/art/quiz-result.webp'
import { HistoryInfoPageStyles as S } from '~/pages/history/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const ImageWrapper = styled(S.ImageWrapper)`
  width: 280px;
  max-width: 100%;
  margin: 0 auto;
`

const ArtQuizResult = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Excellent',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <ImageWrapper>
          <picture>
            <source srcSet={quizResultWEBP} type="image/webp" />
            <img src={quizResultPNG} alt="Excellent" />
          </picture>
        </ImageWrapper>

        <S.Title>
          <Trans ns="art" i18nKey="onboarding.artQuizResult.title" />
        </S.Title>

        <S.Subtitle>
          <Trans ns="art" i18nKey="onboarding.artQuizResult.subtitle" />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default ArtQuizResult
